import script from "./BoardSearcher.vue?vue&type=script&setup=true&lang=ts"
export * from "./BoardSearcher.vue?vue&type=script&setup=true&lang=ts"

import "./BoardSearcher.vue?vue&type=style&index=0&id=36347a2c&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36347a2c"]])

export default __exports__